import ModuleTitle_1 from './ModuleTitle_1.vue';
import ModuleTitle_2 from './ModuleTitle_2.vue';
import ModuleTitle_3 from './ModuleTitle_3.vue';
import ModuleTitle_4 from './ModuleTitle_4.vue';
import ModuleTitle_5 from './ModuleTitle_5.vue';
import ModuleTitle_6 from './ModuleTitle_6.vue';
import ModuleTitle_7 from './ModuleTitle_7.vue';
import ModuleTitle_8 from './ModuleTitle_8.vue';
import ModuleTitle_9 from './ModuleTitle_9.vue';
import ModuleTitle_10 from './ModuleTitle_10.vue';
import ModuleTitle_11 from './ModuleTitle_11.vue';
import ModuleTitle_12 from './ModuleTitle_12.vue';
import ModuleTitle_13 from './ModuleTitle_13.vue';
import ModuleTitle_14 from './ModuleTitle_14.vue';
import ModuleTitle_15 from './ModuleTitle_15.vue';
import ModuleTitle_16 from './ModuleTitle_16.vue';
import ModuleTitle_17 from './ModuleTitle_17.vue';
import ModuleTitle_18 from './ModuleTitle_18.vue';
import ModuleTitle_19 from './ModuleTitle_19.vue';

const ModuleTitleCpt: any = {
  ModuleTitle_1,
  ModuleTitle_2,
  ModuleTitle_3,
  ModuleTitle_4,
  ModuleTitle_5,
  ModuleTitle_6,
  ModuleTitle_7,
  ModuleTitle_8,
  ModuleTitle_9,
  ModuleTitle_10,
  ModuleTitle_11,
  ModuleTitle_12,
  ModuleTitle_13,
  ModuleTitle_14,
  ModuleTitle_15,
  ModuleTitle_16,
  ModuleTitle_17,
  ModuleTitle_18,
  ModuleTitle_19
};

// 模块标题对应快照
export const ModuleTitleScreenShotList = [
  {
    cptName: 'ModuleTitle_1',
    img: 'ModuleTitle_1.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_2',
    img: 'ModuleTitle_2.png',
    iconfont: true
  },
  {
    cptName: 'ModuleTitle_3',
    img: 'ModuleTitle_3.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_4',
    img: 'ModuleTitle_4.png',
    iconfont: true
  },
  {
    cptName: 'ModuleTitle_5',
    img: 'ModuleTitle_5.png',
    iconfont: true
  },
  {
    cptName: 'ModuleTitle_6',
    img: 'ModuleTitle_6.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_7',
    img: 'ModuleTitle_7.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_8',
    img: 'ModuleTitle_8.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_9',
    img: 'ModuleTitle_9.png',
    iconfont: true
  },
  {
    cptName: 'ModuleTitle_10',
    img: 'ModuleTitle_10.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_11',
    img: 'ModuleTitle_11.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_12',
    img: 'ModuleTitle_12.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_13',
    img: 'ModuleTitle_13.png',
    iconfont: true
  },
  {
    cptName: 'ModuleTitle_14',
    img: 'ModuleTitle_14.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_15',
    img: 'ModuleTitle_15.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_16',
    img: 'ModuleTitle_16.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_17',
    img: 'ModuleTitle_17.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_18',
    img: 'ModuleTitle_18.png',
    iconfont: false
  },
  {
    cptName: 'ModuleTitle_19',
    img: 'ModuleTitle_19.png',
    iconfont: false
  }
];

// 模块标题对应的默认图标列表
export const moduleTitleIconList: any = {
  base_info: {
    titleIcon: 'icon-jibenziliao'
  },
  job_intention: {
    titleIcon: 'icon-yixianggangwei'
  },
  edu_background: {
    titleIcon: 'icon-yixianggangwei'
  },
  skill_specialties: {
    titleIcon: 'icon-zhuanyezhishijineng'
  },
  campus_experience: {
    titleIcon: 'icon-jiatimianban_timu'
  },
  internship_experience: {
    titleIcon: 'icon-biyeshixi'
  },
  work_experience: {
    titleIcon: 'icon-gongzuojingyan'
  },
  project_experience: {
    titleIcon: 'icon-xiangmu'
  },
  awards: {
    titleIcon: 'icon-rongyu1'
  },
  hobbies: {
    titleIcon: 'icon-xingquaihao'
  },
  self_evaluation: {
    titleIcon: 'icon-ziwopingjia'
  },
  works_display: {
    titleIcon: 'icon-zhuanyezhishijineng'
  }
};

export default ModuleTitleCpt;
